import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { format as formatTZ, toDate } from "date-fns-tz";
import PropTypes from "prop-types";
import React from "react";

import useStyles from "../useStyles";

/**
 * ReportDateTableコンポーネント.
 *
 * @return {object} コンポーネント
 */
function ReportDateTable(props) {
  // 引数
  const {
    // 判定結果入力済み日付
    dateList,
  } = props;

  // スタイル
  const styles = useStyles();

  // 一覧データの生成
  const createBody = () => {
    const contents = {};
    const years = [];
    const body = {};

    // 取得している日付データを"年"と"月/日"に分割
    if (dateList) {
      dateList.forEach((data) => {
        const year = formatTZ(toDate(new Date(data)), "yyyy", {
          timeZone: "Asia/Tokyo",
        });
        const date = formatTZ(toDate(new Date(data)), "MM/dd", {
          timeZone: "Asia/Tokyo",
        });

        if (contents[year] === undefined) {
          // "年"単位でプロパティを作成
          years.push(year);
          contents[year] = [];
        }
        // "年"単位で"月/日"を配列保持
        contents[year].push(date);
      });

      // 1行での日付表示数を20個に調整
      years.forEach((year) => {
        body[year] = { rowData: [], rowSpan: 1 };
        const list = contents[year];
        const dateCount = list.length;

        // 日付表示数から"年"見出しの縦結合数を算出
        body[year].rowSpan =
          dateCount % 20
            ? Math.floor(dateCount / 20) + 1
            : Math.floor(dateCount / 20);

        // "月/日"を20個ごとに分割 (不足分は"-"埋め)
        for (let row = 0; row < body[year].rowSpan; row++) {
          const rowData = [];
          for (let column = 0; column < 20; column++) {
            const index = row * 20 + column;
            if (list[index]) {
              rowData.push({ id: index, date: list[index] });
            } else {
              rowData.push({ id: index, date: "-" });
            }
          }
          body[year].rowData.push({ id: row, data: rowData });
        }
      });
    }

    return (
      <>
        {years.map((year) => (
          <React.Fragment key={year}>
            {body[year].rowData.map((row) => (
              <TableRow
                className={styles.reportDateTableRow}
                key={`${year}_${row.id}`}
              >
                {row.id === 0 ? (
                  <TableCell
                    className={`${styles.reportDateTableCell} ${styles.reportDateTableYearCell}`}
                    key={year}
                    align="left"
                    rowSpan={body[year].rowSpan}
                    colSpan={1}
                  >
                    {`${year}年`}
                  </TableCell>
                ) : (
                  <></>
                )}
                {row.data.map((data) => (
                  <TableCell
                    className={`${styles.reportDateTableCell} ${styles.reportDateTableDateCell}`}
                    key={`${year}/${data.date}_${data.id}`}
                    align="left"
                    rowSpan={1}
                    colSpan={1}
                  >
                    {data.date}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </React.Fragment>
        ))}
      </>
    );
  };

  return (
    <TableContainer className={styles.reportDateTableContainer}>
      <Table
        className={styles.reportDateTable}
        stickyHeader
        size="small"
        aria-label="report-date-table"
      >
        <TableHead className={styles.reportDateTableHead}>
          <TableRow className={styles.reportDateTableRow}>
            <TableCell
              className={styles.reportDateTableCell}
              align="left"
              rowSpan={1}
              colSpan={21}
            >
              判定結果入力完了日付一覧
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody className={styles.reportDateTableBody}>
          {createBody()}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

ReportDateTable.propTypes = {
  dateList: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default ReportDateTable;
